var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckSquareOffset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 20.25V6.75C5.625 6.45163 5.74353 6.16548 5.95451 5.95451C6.16548 5.74353 6.45163 5.625 6.75 5.625H29.25C29.5484 5.625 29.8345 5.74353 30.0455 5.95451C30.2565 6.16548 30.375 6.45163 30.375 6.75V29.25C30.375 29.5484 30.2565 29.8345 30.0455 30.0455C29.8345 30.2565 29.5484 30.375 29.25 30.375H19.125",
    stroke: "#FF718B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 27L9 30.375L16.875 22.5",
    stroke: "#FF718B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckSquareOffset);
export default __webpack_public_path__ + "static/media/icon-CheckSquareOffset.d04af391178689b1f774683493e22014.svg";
export { ForwardRef as ReactComponent };